import { render, staticRenderFns } from "./GiftBoxList.vue?vue&type=template&id=39e972ef&scoped=true"
import script from "./GiftBoxList.vue?vue&type=script&lang=js"
export * from "./GiftBoxList.vue?vue&type=script&lang=js"
import style0 from "./GiftBoxList.vue?vue&type=style&index=0&id=39e972ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e972ef",
  null
  
)

export default component.exports